import * as React from 'react'

export interface AccordionContextType {
  expanded: boolean
  disabled: boolean
  disableGutters: boolean
  toggle: (event: React.SyntheticEvent) => void
}

export const AccordionContext = React.createContext<AccordionContextType>(
  {} as AccordionContextType
)

if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext'
}
